import { getInitialLanguage, loadI18n, handleDownload, isEmpty, formatCurrency, getCurrencySymbol } from './main.js'

// 任务详情页逻辑

// API基础地址
const API_BASE_URL = '/api'

// 全局变量
let i18nData = {}
let currentLang = 'id'
let taskDetail = null
let isJoining = false

// 应用国际化翻译（本地实现，使用本地的i18nData和currentLang）
function applyI18n() {
  console.log('[task.js] 执行applyI18n，当前语言:', currentLang, '翻译键数量:', Object.keys(i18nData[currentLang] || {}).length)

  // 处理所有可能包含{{i18n:key}}标记的元素
  const allElements = document.querySelectorAll('.h5-share-page, .h5-share-page *')
  allElements.forEach(el => {
    // 处理包含HTML内容的元素的innerHTML
    const innerHTML = el.innerHTML
    if (innerHTML && innerHTML.includes('{{i18n:')) {
      // 使用更安全的方式：查找并替换每个{{i18n:key}}标记
      const newHTML = innerHTML.replace(/\{\{i18n:([^}]+)\}\}/g, (match, key) => {
        return i18nData[currentLang]?.[key] || key
      })
      el.innerHTML = newHTML
    }

    // 处理仅包含文本的元素的textContent
    const textContent = el.textContent
    if (textContent && textContent.includes('{{i18n:') && !innerHTML?.includes('{{i18n:')) {
      const newText = textContent.replace(/\{\{i18n:([^}]+)\}\}/g, (match, key) => {
        return i18nData[currentLang]?.[key] || key
      })
      el.textContent = newText
    }
  })
}

// 从API获取任务详情
async function fetchTaskDetail(planId) {
  const response = await fetch(`${API_BASE_URL}/creator/task/detail?planId=${planId}`)

  if (!response.ok) {
    throw new Error(`HTTP请求错误! 状态码: ${response.status}`)
  }

  return response.json()
}

// 从API获取商品详情
async function fetchProductDetail(productId) {
  const response = await fetch(`${API_BASE_URL}/creator/product/detail?productId=${productId}`)

  if (!response.ok) {
    throw new Error(`HTTP请求错误! 状态码: ${response.status}`)
  }

  return response.json()
}

// 从API获取推荐视频列表
async function fetchRecommendVideos(planId, pageNum = 1, pageSize = 3) {
  const response = await fetch(`${API_BASE_URL}/creator/task/listRecommendVideos?planId=${planId}&pageNum=${pageNum}&pageSize=${pageSize}`)

  if (!response.ok) {
    throw new Error(`HTTP请求错误! 状态码: ${response.status}`)
  }

  return response.json()
}

// 格式化数字
function formatNumber(num) {
  if (!num || num === 0) return '0'
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
  }
  return num.toString()
}

// 渲染任务详情
function renderTaskDetail(data) {
  // 兼容 data.data 和 data 两种格式
  const task = data?.data || data
  if (!task) return

  taskDetail = task

  // 产品图片
  const productMainImage = document.getElementById('productMainImage')
  const productLargeImage = document.getElementById('productLargeImage')
  if (task.productMainImageUrl) {
    if (productMainImage) {
      productMainImage.src = task.productMainImageUrl
      productMainImage.style.display = 'block'
    }
    if (productLargeImage) {
      productLargeImage.src = task.productMainImageUrl
    }
  }

  // 产品名称
  const productName = document.getElementById('productName')
  if (task.productName && productName) {
    productName.textContent = task.productName
  }

  // 类目
  const categoryName = document.getElementById('categoryName')
  if (task.categoryName && categoryName) {
    categoryName.textContent = task.categoryName
  }

  // 佣金（使用 creatorCommission 字段）
  const videoReward = document.getElementById('videoReward')
  const currencySymbol = getCurrencySymbol(task.currency)
  if (task.creatorCommission !== null && task.creatorCommission !== undefined && videoReward) {
    // 只格式化千分符，不固定小数点
    const isDotSeparator = currencySymbol.includes('Rp') || currencySymbol.includes('IDR') || currencySymbol.includes('₫') || currencySymbol.includes('VND')
    const separator = isDotSeparator ? '.' : ','
    const amountNum = Math.floor(task.creatorCommission)
    const formattedInteger = amountNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
    videoReward.textContent = `${currencySymbol}${formattedInteger}`
  }

  // 佣金率
  const creatorCommissionRate = document.getElementById('creatorCommissionRate')
  if (task.creatorCommissionRate !== null && task.creatorCommissionRate !== undefined && creatorCommissionRate) {
    creatorCommissionRate.textContent = `${(parseFloat(task.creatorCommissionRate) / 100).toFixed(2)}%`
  }

  // 进度百分比
  const progressPercentage = task.videoProgressPercentage || task.progressPercentage || 0
  updateProgress(progressPercentage, task.totalVideoReward || 0, task.participantCreators || 0, currencySymbol)

  // 资格条件
  const gmvLimit = task.promoGmvLimit
  const videoLimit = task.promoVideoLimit
  
  if (gmvLimit != null || videoLimit != null) {
    const eligibilitySection = document.getElementById('eligibilitySection')
    const eligibilityContent = document.getElementById('eligibilityContent')
    if (eligibilitySection && eligibilityContent) {
      eligibilitySection.style.display = 'block'
      const thirtyDaysGMVTemplate = i18nData[currentLang]?.thirtyDaysGmv || '过去30天GMV>{gmv}；30天播放量>{views}'
      const creatorDataText = i18nData[currentLang]?.creatorData || '达人数据统计时间：每月1号更新'
      
      const gmvFormatted = `${currencySymbol}${formatCurrency(gmvLimit, currencySymbol)}`
      const viewsFormatted = formatNumber(videoLimit)
      
      eligibilityContent.innerHTML = `
        <div>${thirtyDaysGMVTemplate.replace('{gmv}', gmvFormatted).replace('{views}', viewsFormatted)}</div>
        <div>${creatorDataText}</div>
      `
    }
  }

  // 任务周期
  if (task.taskStartDate !== null && task.taskEndDate !== null) {
    const taskPeriodSection = document.getElementById('taskPeriodSection')
    const taskPeriodContent = document.getElementById('taskPeriodContent')
    if (taskPeriodSection && taskPeriodContent) {
      taskPeriodSection.style.display = 'block'
      taskPeriodContent.textContent = `${task.taskStartDate} ~ ${task.taskEndDate}`
    }
  }

  // 视频数量要求
  const videoCountSection = document.getElementById('videoCountSection')
  const videoCountContent = document.getElementById('videoCountContent')
  if (videoCountSection && videoCountContent) {
    videoCountSection.style.display = 'block'
    const atLeastText = i18nData[currentLang]?.atLeast || '至少'
    const videosText = i18nData[currentLang]?.videos || '个视频'
    if (task.targetVideos !== null && task.targetVideos !== undefined) {
      videoCountContent.textContent = `${atLeastText} ${task.targetVideos} ${videosText}`
    } else {
      // 备用文本：至少3个视频
      const atLeast3Videos = i18nData[currentLang]?.atLeast3Videos || '至少3个视频'
      videoCountContent.textContent = atLeast3Videos
    }
  }

  // 更新页面标题
  document.title = task.productName || i18nData[currentLang]?.taskDetailTitle || '任务详情'
}

// 更新进度条
function updateProgress(percentage, totalReward, participants, currencySymbol = 'Rp') {
  const progressFill = document.getElementById('progressFill')
  const progressBubble = document.getElementById('progressBubble')
  const progressBubbleWrapper = document.querySelector('.progress-bubble-wrapper')
  const totalVideoReward = document.getElementById('totalVideoReward')
  const participantLabel = document.getElementById('participantLabel')

  if (progressFill) {
    progressFill.style.width = `${percentage}%`
  }

  if (progressBubble) {
    progressBubble.textContent = `${percentage}%`
  }

  if (progressBubbleWrapper) {
    // 让气泡跟随进度，百分比乘以100是为了转换为CSS的百分比单位
    progressBubbleWrapper.style.left = `${percentage}%`
  }

  if (totalVideoReward) {
    // 只格式化千分符，不固定小数点
    const amountNum = Math.floor(totalReward || 0)
    const isDotSeparator = currencySymbol.includes('Rp') || currencySymbol.includes('IDR') || currencySymbol.includes('₫') || currencySymbol.includes('VND')
    const separator = isDotSeparator ? '.' : ','
    const formattedInteger = amountNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
    totalVideoReward.textContent = `${currencySymbol}${formattedInteger}`
  }

  if (participantLabel) {
    const creatorsText = i18nData[currentLang]?.creatorsParticipating || '{count}位创作者已加入'
    participantLabel.textContent = creatorsText.replace('{count}', participants || 0)
  }
}

// 渲染商品详情数据（用于概览部分）
function renderProductDetail(product) {
  // 兼容 product.data 和 product 两种格式
  const data = product?.data || product
  if (!data) return

  // 价格
  const productPrice = document.getElementById('productPrice')
  if (data.lowestPrice && productPrice) {
    const currencySymbol = getCurrencySymbol(data.currency)
    productPrice.textContent = `${currencySymbol}${formatCurrency(data.lowestPrice, currencySymbol)}`
  }

  // 销量
  const totalSales = document.getElementById('totalSales')
  if (data.productSales && totalSales) {
    totalSales.textContent = formatNumber(data.productSales)
  }

  // 库存
  const stock = document.getElementById('stock')
  if (data.inventory && stock) {
    stock.textContent = formatNumber(data.inventory)
  }

  // 样品配额
  const samples = document.getElementById('samples')
  if (data.sampleQuota && samples) {
    samples.textContent = formatNumber(data.sampleQuota)
  }
}

// 渲染推荐视频列表
function renderVideos(res) {
  const container = document.getElementById('taskVideosList')
  if (!container) {
    console.error('[renderVideos] 找不到 taskVideosList 容器')
    return
  }

  console.log('[renderVideos] 原始数据:', res)

  const viewsText = i18nData[currentLang]?.views || '播放量'
  const likesText = i18nData[currentLang]?.likes || '点赞数'
  const gmvText = 'GMV'
  const videos = res?.data?.list;
  if (!videos || videos.length === 0) {
    console.warn('[renderVideos] 视频数据为空')
    const noVideosText = i18nData[currentLang]?.noSimilarVideos || '暂无相似视频参考'
    container.innerHTML = `<div class="no-videos">${noVideosText}</div>`
    return
  }

  const videoList = videos
  console.log('[renderVideos] videoList:', videoList, '长度:', videoList.length)

  container.innerHTML = videoList.map((video, index) => {
    const gmvValue = video.gmv ? formatCurrency(video.gmv, '¥') : '0'
    return `
    <div class="video-item" data-video-index="${index}">
      <div class="video-thumbnail">
        <span class="video-play-icon">▶</span>
      </div>
      <div class="video-info">
        <div class="video-name">${video.videoName || '未知视频'}</div>
        <div class="video-stats">
          <div class="video-stat-item">
            <div class="video-stat-value">${formatNumber(video.viewCount || 0)}</div>
            <div class="video-stat-label">${viewsText}</div>
          </div>
          <div class="video-stat-item">
            <div class="video-stat-value">${formatNumber(video.likeCount || 0)}</div>
            <div class="video-stat-label">${likesText}</div>
          </div>
          <div class="video-stat-item">
            <div class="video-stat-value">¥${gmvValue}</div>
            <div class="video-stat-label">${gmvText}</div>
          </div>
        </div>
      </div>
    </div>
  `
  }).join('')

  // 绑定点击事件
  const videoItems = container.querySelectorAll('.video-item')
  videoItems.forEach((item, index) => {
    const video = videoList[index]
    if (video && video.videoUrl) {
      item.style.cursor = 'pointer'
      item.addEventListener('click', () => {
        window.open(video.videoUrl, '_blank')
      })
    }
  })
}

// 初始化Tab切换
function initTabs() {
  const tabItems = document.querySelectorAll('.tab-item')
  const tabContents = document.querySelectorAll('.tab-content')

  tabItems.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabIndex = tab.dataset.tab

      // 切换tab样式
      tabItems.forEach(item => item.classList.remove('active'))
      tab.classList.add('active')

      // 切换内容显示
      tabContents.forEach(content => {
        content.classList.remove('active')
        if (content.dataset.content === tabIndex) {
          content.classList.add('active')
        }
      })
    })
  })
}

// 初始化任务规则内容
function initTaskRules() {
  const content = document.getElementById('taskRuleRequirementsContent')
  if (!content) return

  const requirement1 = i18nData[currentLang]?.taskRuleRequirement1 || '1. 视频内容需与商品强相关，且包含商品使用场景展示'
  const requirement2 = i18nData[currentLang]?.taskRuleRequirement2 || '2. 视频需在规定时间内提交，逾期将无法获得奖励'
  const requirement3 = i18nData[currentLang]?.taskRuleRequirement3 || '3. 视频需通过审核，不符合要求将被拒绝'
  const requirement4 = i18nData[currentLang]?.taskRuleRequirement4 || '4. 提交后请耐心等待审核结果'
  const requirement5 = i18nData[currentLang]?.taskRuleRequirement5 || '5. 审核通过后，奖励将自动发放'

  content.innerHTML = `${requirement1}\n${requirement2}\n${requirement3}\n${requirement4}\n${requirement5}`
}

// 渲染产品描述
function renderProductDescription(description) {
  const content = document.getElementById('productDescription')
  if (!content) return

  const noDescriptionText = i18nData[currentLang]?.noDescription || '暂无产品卖点'
  content.textContent = description || noDescriptionText
}

// 参加任务
async function handleJoin() {
  if (isJoining) return

  const urlParams = new URLSearchParams(window.location.search)
  const planId = urlParams.get('planId')

  if (!planId) {
    alert('任务ID不存在')
    return
  }

  const joinBtn = document.getElementById('joinBtn')
  if (joinBtn) {
    joinBtn.disabled = true
  }

  isJoining = true

  try {
    const response = await fetch(`${API_BASE_URL}/creator/task/participate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ planId })
    })

    const result = await response.json()

    if (result.isSuccess || result.code === 200) {
      alert(i18nData[currentLang]?.joinSuccess || '您已成功参加此任务')
    } else {
      alert(result.message || i18nData[currentLang]?.joinFailed || '参加失败，请稍后重试')
    }
  } catch (error) {
    console.error('参加任务失败:', error)
    alert(i18nData[currentLang]?.joinError || '网络错误，请稍后重试')
  } finally {
    isJoining = false
    if (joinBtn) {
      joinBtn.disabled = false
    }
  }
}

// 初始化应用
async function init() {
  // 设置初始语言
  currentLang = getInitialLanguage()

  // 加载国际化数据
  i18nData[currentLang] = await loadI18n(currentLang)

  // 应用国际化翻译
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applyI18n()
      initTaskRules()
    })
  } else {
    applyI18n()
    initTaskRules()
  }

  // 从URL获取planId（支持plan和planId两种参数名）
  const urlParams = new URLSearchParams(window.location.search)
  const planId = urlParams.get('planId') || urlParams.get('plan')

  if (!planId) {
    // 没有planId，显示错误
    document.getElementById('loadingState').style.display = 'none'
    document.getElementById('errorState').style.display = 'flex'
    return
  }

  const loadingState = document.getElementById('loadingState')
  const pageMain = document.getElementById('pageMain')
  const errorState = document.getElementById('errorState')

  try {
    // 加载任务详情
    const task = await fetchTaskDetail(planId)
    const taskData = task.data || task

    // 验证任务数据有效性
    if (!taskData || !taskData.productName) {
      throw new Error('任务数据无效')
    }

    renderTaskDetail(task)

    // 如果有productId，加载商品详情
    if (taskData.productId) {
      try {
        const product = await fetchProductDetail(taskData.productId)
        renderProductDetail(product)
      } catch (error) {
        console.error('加载商品详情失败:', error)
      }
    }

    // 加载推荐视频
    try {
      const videos = await fetchRecommendVideos(planId)
      console.log('[init] API 返回的推荐视频数据:', videos)
      renderVideos(videos)
    } catch (error) {
      console.error('加载推荐视频失败:', error)
    }

    // 渲染产品描述
    renderProductDescription(taskData.productDescription)

    // 显示主内容
    if (loadingState) loadingState.style.display = 'none'
    if (pageMain) pageMain.style.display = 'block'

    // 初始化Tab切换
    initTabs()

    // 绑定下载按钮事件
    const downloadBtn = document.getElementById('downloadBtn')
    if (downloadBtn) {
      downloadBtn.addEventListener('click', handleDownload)
    }

  } catch (error) {
    console.error('加载数据失败:', error)
    // 显示错误状态，隐藏主内容
    if (loadingState) loadingState.style.display = 'none'
    if (pageMain) pageMain.style.display = 'none'
    if (errorState) errorState.style.display = 'flex'
  }
}

// DOM加载完成后启动应用
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
